import { STORE } from "../../store";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { RatingScreen } from "../../actions/common";
import ChatWindowOptions from "../ChatWindowOptions";
import CancelIcon from '@mui/icons-material/Cancel';

export default function Heading() {
  const location = useLocation();

  const environment = useSelector((state: any) => state?.environment);
  const design = useSelector((state: any) => state?.design);
  const configuration = useSelector((state: any) => state?.configuration);


  const updateState = () => {
    const pathParts = location.pathname.split('/');
    const userId = pathParts[pathParts.length - 1];
    const botId = pathParts[pathParts.length - 2];
    const ratingExist = sessionStorage.getItem('BotPenguin_rating');

    if (ratingExist || !configuration.chatMenu.isRatingEnabled) {
      const botpenguin = new (window as any).parent.BotPenguin();
      botpenguin.closeWindow();
      localStorage.setItem('bp-user-close', 'true');
      STORE.dispatch(RatingScreen(false));
    } else if (botId && userId) {
      STORE.dispatch(RatingScreen(true));
    } else {
      STORE.dispatch(RatingScreen(true));
    }
  };

  return (
    <>
      <div id="ele-header" className="p-4 bg-bpPrimary rounded-xl flex flex-row justify-between h-full text-white" style={{ backgroundColor: design.themeColor || '#226CF4' }}>
        <div id='ele-01' className="flex flex-row justify-start items-center">
          {/* 
            Commented untill this images are rendered via agents profile
            <div className="flex -space-x-4 relative">
              <img className="inline-block h-8 w-8 rounded-full ring-1 ring-white" src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
              <img className="inline-block h-8 w-8 rounded-full ring-1 ring-white" src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="" />
              <img className="inline-block h-8 w-8 rounded-full ring-1 ring-white" src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80" alt="" />          
            </div> 
          */}

          <div className="flex relative" id='ele-02'>
            <img id='ele-03' className="inline-block h-8 w-8 min-w-8 rounded-full bg-white" src={design.avatar} alt="" />
          </div>

          <div id='ele-185' className={`grid grid-cols-1 ${environment?.direction === 'ltr' ? 'ml-4' : 'mr-4'}`}>
            <div id='ele-186' className="font-mSemiBold text-base">
              {design?.name}
            </div>
            {configuration && configuration.generalSettings && configuration.generalSettings.waitingMessage &&
              <div id='ele-187' className="text-xs flex flex-row justify-start items-center">
                <img src={process.env.REACT_APP_CDN + "/clock.svg"} alt="clock" className={`inline-block ${environment?.direction === 'ltr' ? 'mr-1' : 'ml-1'}`} /> <span className="opacity-75 text-xs truncate text-nowrap">{configuration.generalSettings.waitingMessage}</span>
              </div>
            }
          </div>
        </div>

        <div id='ele-188' className="flex flex-row justify-end h-full items-center">
          {/* Show options only if any one of them is enabled */}
          {
            (!configuration?.chatMenu?.hideTransferToWhatsApp || configuration?.chatMenu?.toLiveChat || configuration?.chatMenu?.refreshChat)
            && <ChatWindowOptions color='#fff' />
          }
          {
            environment && environment.viewType === 'launcher-icon' &&
            <div id='ele-189' className="cursor-pointer hover:opacity-70" onClick={updateState}>
              <CancelIcon className="align-middle !text-3xl" />
            </div>
          }
        </div>
      </div >

    </>
  )
}
